import { useEffect } from 'react';

const APP_PREFIX = 'Nano Portal (Beta) - ';

export const usePageTitle = (title) => {
  useEffect(() => {
    const previousTitle = document.title;
    const fullTitle = title ? `${APP_PREFIX}${title}` : APP_PREFIX.slice(0, -3); // Remove the dash and space if no title
    document.title = fullTitle;
    
    // Update social media meta tags with the same title
    const updateMetaTag = (selector, content) => {
      const metaTag = document.querySelector(selector);
      if (metaTag) {
        metaTag.setAttribute('content', content);
      }
    };
    
    // Update Open Graph title
    updateMetaTag('meta[property="og:title"]', fullTitle);
    
    // Update Twitter title
    updateMetaTag('meta[name="twitter:title"]', fullTitle);
    
    // Update Apple mobile web app title
    updateMetaTag('meta[name="apple-mobile-web-app-title"]', fullTitle);
    
    // Update application name
    updateMetaTag('meta[name="application-name"]', fullTitle);
    
    // Cleanup function to restore previous title (optional)
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default usePageTitle;